/** Small label for org AI-generated buyer personas (not platform catalog). */
export function PersonaAiBadge({
  className = '',
  variant = 'light',
}: {
  className?: string;
  variant?: 'light' | 'dark';
}) {
  const base =
    variant === 'dark'
      ? 'text-xs px-2 py-1 rounded font-medium shrink-0 bg-red-900/50 text-red-200 border border-red-700/50'
      : 'text-xs px-2 py-1 bg-red-50 text-red-800 rounded font-medium shrink-0';
  return <span className={`${base} ${className}`.trim()}>AI</span>;
}
